import { useCallback } from 'react';
import { useErrorReporting } from '../../context/ErrorReportingContext';
import { useSignout } from '../useSignout';
import { FetchError } from './FetchError';
import { reportIfTokenExpired } from './reportIfTokenExpired';
export function useFetch(tokenFetcher) {
    const { signout } = useSignout();
    const errorReporting = useErrorReporting();
    const request = useCallback(async (input, init = {}) => {
        const accessToken = await tokenFetcher();
        if (!accessToken) {
            throw Error('no access token');
        }
        reportIfTokenExpired(accessToken, errorReporting);
        const response = await fetch(input, {
            ...init,
            credentials: 'omit',
            headers: {
                ...init.headers,
                Authorization: `Bearer ${accessToken}`,
            },
        });
        if (response.status === 401) {
            try {
                if (errorReporting) {
                    const authError = new Error(`user not authorised for request: ${input.toString()}`);
                    authError.name = 'DashboardUserAuthError';
                    errorReporting.datadog.addError(authError);
                }
            }
            catch {
                // eslint-disable-next-line no-console
                console.error('could not send error report');
            }
            signout();
        }
        if (!response.ok) {
            throw new FetchError(response.statusText, response.status, response);
        }
        return response;
    }, [errorReporting, signout, tokenFetcher]);
    return request;
}
